import ButtonImageImport from "./ButtonImage";
import ImageImport from "./Image";
import ImageLoaderImport from "./ImageLoader";

export const ButtonImage = ButtonImageImport;
export const Image = ImageImport;
export const ImageLoader = ImageLoaderImport;
